import React, { useEffect, useState } from 'react'
import { useInstantSearch, useRefinementList } from 'react-instantsearch'

import { Checkbox } from '@audio-network/componentlibrary'
import CheckboxList from '../CheckboxList/CheckboxList'
import CheckboxListItem from '../CheckboxListItem/CheckboxListItem'
import ProFacets from './ProFacets'
import styles from './ProFilter.module.css'

const ProFilter = (
	props: JSX.IntrinsicAttributes &
		React.ClassAttributes<HTMLUListElement> &
		React.HTMLAttributes<HTMLUListElement>
): JSX.Element => {
	const [displayItems, setDisplayItems] = useState([])
	const { setIndexUiState, indexUiState } = useInstantSearch()

	//Need to mount the widget for this to work:
	//https://www.algolia.com/doc/api-reference/widgets/use-instantsearch/react/#widget-param-setindexuistate
	useRefinementList({
		attribute: 'Composers.CollectionSociety',
		operator: 'and',
		sortBy: ['name'],
		limit: 56111, //Force it to show all
	})

	const toggleProRefinedState = (pro: string): void => {
		const proIndex = displayItems.findIndex((item) => item.value === pro)
		const temp = [...displayItems]
		temp[proIndex].isRefined = !temp[proIndex].isRefined
		setDisplayItems(temp)
	}

	const buildProExclusionList = (): string[] => {
		if (!displayItems.find((item) => item.isRefined)) {
			return []
		} else {
			const refinedValues = displayItems.filter(
				(item) => item.isRefined === false
			)
			if (refinedValues) {
				return refinedValues.map(({ value }) => {
					return `-${value}`
				})
			}
		}
	}

	useEffect(() => {
		const proRefinementList =
			indexUiState?.refinementList === undefined
				? null
				: indexUiState?.refinementList['Composers.CollectionSociety']

		const tempDisplayList = []
		ProFacets.forEach((facet) => {
			let isRefined = false
			if (proRefinementList) {
				isRefined =
					proRefinementList.find((item) => item === `-${facet.value}`) ===
					undefined
			} else {
				isRefined = false
			}

			tempDisplayList.push({
				isRefined: isRefined,
				label: facet.value,
				value: facet.value,
			})
		})
		setDisplayItems(tempDisplayList)
	}, [indexUiState?.refinementList])

	const filterByPro = (pro: string): void => {
		toggleProRefinedState(pro)

		setIndexUiState((prevUIState) => ({
			...prevUIState,
			refinementList: {
				...prevUIState.refinementList,
				'Composers.CollectionSociety': buildProExclusionList(),
			},
		}))
	}

	return (
		<CheckboxList className={styles.proFilter} {...props}>
			{displayItems.map((item) => (
				<CheckboxListItem key={item.value}>
					<Checkbox
						label={<>{item.label}</>}
						name={item.value}
						checked={item.isRefined}
						onChange={() => {
							filterByPro(item.value)
						}}
					/>
				</CheckboxListItem>
			))}
		</CheckboxList>
	)
}

export default ProFilter
